export const sanitizeId = (innerText: string): string => {
  if (!innerText) return null;
  return innerText
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
};
